export const mapKeys = <T, V, U>(
  m: Map<T, V>,
  fn: (this: void, v: V) => U
): Map<T, U> => {
  function transformPair([k, v]: [T, V]): [T, U] {
    return [k, fn(v)]
  }

  return new Map(Array.from(m.entries(), transformPair))
}

export const generatePaginationFromKey = (key: string) => {
  return {
    pagination: {
      key
    }
  }
}

export const uniqueId = (characters: number = 6): string =>
  (
    Number(String(Math.random()).slice(2)) +
    Date.now() +
    Math.round(performance.now())
  ).toString(characters)

export const headTitle =
  'Injective Staking - DeFi DEX | Fast, secure and fully decentralized trading.'

export const metaTags = (): {
  appMetaTags: () => Object[]
  pwaMetaTags: () => Object
  manifestMetaTags: () => Object
} => {
  const title =
    'Injective Protocol Staking - Access Limitless DeFi Markets with Zero Barriers.'
  const description =
    'Injective is the first front-running resistant, layer-2 exchange protocol that unlocks the full potential of borderless finance by supporting margin trading, derivatives, and futures.'
  const keywords =
    'staking, injective protocol, dapp, decentralized app, cryptocurrency, criptocurrency exchange, exchange, exchange token, ethereum, ethereum token, erc20, futures, perpetuals, futures protocol'
  const author = 'InjectiveProtocol'

  const appMetaTags = () => [
    {
      hid: 'og:url',
      property: 'og:url',
      content: `${process.env.APP_BASE_URL}`
    },
    { hid: 'keywords', name: 'keywords', content: keywords },
    { hid: 'description', name: 'description', content: description },
    { hid: 'author', name: 'author', content: author },
    { hid: 'og:type', property: 'og:type', content: 'exchange' },
    {
      hid: 'og:image',
      property: 'og:image',
      content: `${process.env.APP_BASE_URL}/images/equinox-staking.jpg`
    },
    {
      hid: 'og:description',
      property: 'og:description',
      content: description
    },
    {
      hid: 'twitter:card',
      property: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      hid: 'twitter:site',
      property: 'twitter:site',
      content: '@InjectiveLabs'
    },
    {
      name: 'twitter:image',
      content: `${process.env.APP_BASE_URL}/images/equinox-staking.jpg`
    },
    {
      hid: 'twitter:creator',
      property: 'twitter:creator',
      content: '@InjectiveLabs'
    },
    {
      hid: 'twitter:description',
      property: 'twitter:description',
      content: description
    },
    {
      hid: 'twitter:title',
      property: 'twitter:title',
      content: title
    },
    { hid: 'og:title', property: 'og:title', content: title },
    { hid: 'og:site_name', property: 'og:site_name', content: title },
    { hid: 'title', property: 'title', content: title }
  ]

  const pwaMetaTags = () => {
    return {
      name: title,
      description,
      theme_color: 'dark',
      ogSiteName: title,
      ogTitle: title,
      ogDescription: description,
      ogHost: 'https://staking.injective.network',
      ogUrl: 'https://staking.injective.network',
      ogImage: `${process.env.APP_BASE_URL}/images/equinox-staking.jpg`,
      twitterCard: 'summary_large_image',
      twitterSite: '@InjectiveLabs',
      twitterCreator: '@InjectiveLabs'
    }
  }

  const manifestMetaTags = () => {
    return {
      name: title,
      description,
      short_name: 'Injective Staking',
      theme_color: 'dark'
    }
  }

  return {
    appMetaTags,
    pwaMetaTags,
    manifestMetaTags
  }
}
